module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 bg-lightest mb-4 pb-4"
  }, [_c('div', {
    staticClass: "px-5"
  }, [_c('div', {
    staticClass: "dark fs-super pt-4 pb-3"
  }, [_vm._v(_vm._s(_vm.niceDate(_vm.group.date)))]), _vm._v(" "), _c('table', {
    staticClass: "w-100"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.group.events), function(event) {
    return _c('tr', {
      key: event.id,
      staticClass: "fs-large"
    }, [_c('td', {
      staticClass: "fs-larger"
    }, [_vm._v(_vm._s(_vm.startHour(event.start)))]), _vm._v(" "), _c('td', {
      staticClass: "slightlySmallerText"
    }, [_vm._v(_vm._s(_vm.resources(event)))]), _vm._v(" "), _c('td', {
      staticClass: "slightlySmallerText"
    }, [_vm._v(_vm._s(_vm.hourToDuration(event.duration)))]), _vm._v(" "), _c('td', {
      staticClass: "slightlySmallerText text-center relative"
    }, [_c('div', {
      staticClass: "mt-2"
    }, [_c('span', [_vm._v(_vm._s(event.eventGenderPrices[0].audienceTypeDescription))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatPrice(event.eventGenderPrices[0].grossprice)) + " €")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "click-outside",
        rawName: "v-click-outside",
        value: (_vm.closeBox),
        expression: "closeBox"
      }],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toogleBox(event.id)
        }
      }
    }, [_c('div', {
      staticClass: "fs-smaller fa fa-info-circle medium ml-1 p-2",
      attrs: {
        "type": "button"
      }
    }), _vm._v(" "), (_vm.showBox[event.id]) ? _c('div', {
      staticClass: "floating-menu left centered d-flex flex-column"
    }, _vm._l((_vm.showPrices(event)), function(price) {
      return _c('ul', {
        key: price.id
      }, [_c('li', {
        staticClass: "normal"
      }, [_vm._v(_vm._s(price))])])
    }), 0) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "fs-largest"
    }, [_c('b', [_vm._v(_vm._s(event.quantityAvailable))]), _vm._v("/" + _vm._s(event.maximumLotation) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "fs-smaller"
    }, [_vm._v(_vm._s(event.maximumLotation - event.quantityAvailable) + " booked")])]), _vm._v(" "), (_vm.$route.meta.reschedule) ? _c('td', {
      class: {
        'd-flex': _vm.isAdmin && _vm.rejectBookingBasedOnMinMax(event) && (!_vm.isMinLimitsSatisfied(event) || !_vm.isMaxLimitsSatisfied(event)),
        'text-center': true
      }
    }, [(_vm.isAdmin && _vm.rejectBookingBasedOnMinMax(event)) ? _c('div', {
      staticClass: "d-flex align-items-center ml-5"
    }, [(!_vm.isMinLimitsSatisfied(event)) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (_vm.minLimitsMessage(event)),
        expression: "minLimitsMessage(event)"
      }],
      staticClass: "ico-alert color-6 fs-largest"
    }) : _vm._e(), _vm._v(" "), (!_vm.isMaxLimitsSatisfied(event)) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (_vm.maxLimitsMessage(event)),
        expression: "maxLimitsMessage(event)"
      }],
      staticClass: "ico-alert color-6 fs-largest"
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isAdmin || !(_vm.rejectBookingBasedOnMinMax(event) && !_vm.isMinLimitsSatisfied(event)) && !(_vm.rejectBookingBasedOnMinMax(event) && !_vm.isMaxLimitsSatisfied(event)) && _vm.canISellThisEvent(event).allowed) ? _c('button', {
      class: {
        'btn widest bg-color-2 border-color-2 fs-large my-2': true,
        'ml-5': _vm.isAdmin && _vm.rejectBookingBasedOnMinMax(event) && (!_vm.isMinLimitsSatisfied(event) || !_vm.isMaxLimitsSatisfied(event))
      },
      attrs: {
        "disabled": _vm.getIsRescheduling
      },
      on: {
        "click": function($event) {
          return _vm.reschedulePrompt(event)
        }
      }
    }, [_vm._v(_vm._s(_vm.selectedEvent && _vm.selectedEvent.id == event.id && _vm.getIsRescheduling ? 'REBOOKING' : 'REBOOK') + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.canISellThisEvent(event).allowed && !_vm.isAdmin) ? _c('button', {
      staticClass: "btn widest bg-dark fs-large my-2",
      on: {
        "click": function($event) {
          return _vm.showChannelClosedPopup(event)
        }
      }
    }, [_vm._v("CLOSED")]) : (_vm.rejectBookingBasedOnMinMax(event) && !_vm.isMinLimitsSatisfied(event)) ? _c('div', [_c('AlertMessage', {
      attrs: {
        "message": _vm.minLimitsMessage(event),
        "icon": "ico-alert",
        "bold": ""
      }
    })], 1) : (_vm.rejectBookingBasedOnMinMax(event) && !_vm.isMaxLimitsSatisfied(event)) ? _c('div', [_c('AlertMessage', {
      attrs: {
        "message": _vm.maxLimitsMessage(event),
        "icon": "ico-alert",
        "bold": ""
      }
    })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.reschedule) ? _c('td', {
      staticClass: "text-center"
    }, [(event.status == -1) ? _c('button', {
      staticClass: "btn widest border-color-6 bg-color-6 lightest fs-large my-2",
      on: {
        "click": function($event) {
          return _vm.showCanceledPopup(event)
        }
      }
    }, [_vm._v("EVENT CANCELED")]) : _vm._e(), _vm._v(" "), (!_vm.canISellThisEvent(event).allowed && !_vm.isAdmin) ? _c('button', {
      staticClass: "btn widest bg-dark fs-large my-2 btn-size",
      on: {
        "click": function($event) {
          return _vm.showChannelClosedPopup(event)
        }
      }
    }, [_vm._v("CLOSED")]) : _c('button', {
      staticClass: "btn widest border-color-3 fs-large my-2 btn-size",
      on: {
        "click": function($event) {
          return _vm.book(event)
        }
      }
    }, [_vm._v("BOOK")])]) : _vm._e()])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "bg-lighter dark bold"
  }, [_c('th', {
    staticClass: "startHourWidth"
  }, [_vm._v("Departure")]), _vm._v(" "), _c('th', [_vm._v("Resource")]), _vm._v(" "), _c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Prices")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Available/total")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-273155f1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-273155f1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Availability/SingleDay.vue
// module id = 2782
// module chunks = 0